export const assistantRouter = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  //   meta: {
  //     index: 1,
  //     keepAlive: false
  //   }
  // }
]
